// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {StudentLandingModuleLayout} from 'app_components/modules/admin/landings/studentLanding'
import { ILanding } from 'app_types/admin/landings/landingTypes'
import LandingService from 'app_services/admin/landings/landingService'
import PermissionService from 'app_services/secure/permission/permissionService'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
// @end

// @import types
// @end

// @ADD Component types
interface IStudentLandingModuleProps {}
interface IStudentLandingModuleState {
  landingInfo: ILanding | null
  status: null | 'loading' | 'error'
  loadingForm: null | 'loading'
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class StudentLandingModule extends Component<IStudentLandingModuleProps, IStudentLandingModuleState> {

  public moduleName: string = 'module:landings'
  private landingService: LandingService
  private permission: PermissionService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: IStudentLandingModuleProps) {
    super(props)
    this.state = {
      status: 'loading',
      landingInfo: null,
      loadingForm: null
    }
    this.landingService = new LandingService()
    this.permission = new PermissionService(this.moduleName)
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    await this.fetchLandingData()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  fetchLandingData = async () => {
    this.setState({ status: 'loading' })

    let httpParams: any = {
      slug: 'student'
    }

    let landing: ILanding | null = null

    const landingResponse = await this.landingService.fetchLandingData(httpParams)

    if (landingResponse) {
      landing = landingResponse
    }

    this.setState({
      landingInfo: landing,
      status: null
    })
  }

  onHandleSchedulingSubmit = async (data: any) => {
    if (data.status === 'success') {
      await this.fetchLandingData()
    }
  }

  render() {
    return(
      <StudentLandingModuleLayout
        {...this.props}
        onHandleSchedulingSubmit={this.permission.check('permission:landings_teacher_scheduling', this.onHandleSchedulingSubmit)}
        landingInfo={this.state.landingInfo}
        loadingForm={this.state.loadingForm}
        permission={this.permission}
      />
    )
  }
}

export default connect(mapStatesToProps)(StudentLandingModule)
